import { render, staticRenderFns } from "./DeletedPatients.vue?vue&type=template&id=1bca663a&"
import script from "./DeletedPatients.vue?vue&type=script&lang=js&"
export * from "./DeletedPatients.vue?vue&type=script&lang=js&"
import style0 from "./DeletedPatients.vue?vue&type=style&index=0&id=1bca663a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports